import { FunctionComponent, useContext } from 'react'
import styled, { css } from 'styled-components'
import contextToiTeaser from '@contexts/toiTeaser'
import { TOITeaserLayoutContextType } from '@contexts/toiTeaser'
import { ExtraDataWrapperProps } from '@widgets/Teaser/toi/types'

interface StyledExtraDataWrapperProps
  extends Pick<ExtraDataWrapperProps, 'hasPromo'>,
    Pick<TOITeaserLayoutContextType, 'articleType'> {
  alignment: TOITeaserLayoutContextType['mainTextAlignment']
}

const { TOITeaserLayoutContext } = contextToiTeaser

const StyledExtraDataWrapper = styled.div<StyledExtraDataWrapperProps>`
  position: absolute;
  display: grid;
  row-gap: 10px;

  ${({ hasPromo, alignment, articleType }) => {
    return css`
      justify-items: ${alignment.h === 'left' ? 'end' : 'start'};
      ${articleType === 'default' && alignment.v === 'top'
        ? 'bottom'
        : 'top'}: ${hasPromo ? '22px' : '8px'};
      ${alignment.h === 'left' ? 'right' : 'left'}: ${hasPromo
        ? '20px'
        : '8px'};
    `
  }}
`

const ExtraDataWrapper: FunctionComponent<ExtraDataWrapperProps> = ({
  children,
  hasPromo,
}) => {
  const { mainTextAlignment, articleType } = useContext(TOITeaserLayoutContext)

  return (
    <StyledExtraDataWrapper
      hasPromo={hasPromo}
      alignment={mainTextAlignment}
      articleType={articleType}>
      {children}
    </StyledExtraDataWrapper>
  )
}

export default ExtraDataWrapper
